// ../../components/report/CurriculumCsvUpload.js
import React from "react";

const CurriculumCsvUpload = ({ onImported }) => {
  const parseCsv = (text) => {
    const lines = text.trim().split(/\r?\n/);
    const result = [];

    const first = lines[0] || "";
    const hasHeader =
      first.includes("科目") &&
      first.includes("単元") &&
      (first.includes("必要コマ数") || first.includes("必要コマ"));

    const startIndex = hasHeader ? 1 : 0;

    for (let i = startIndex; i < lines.length; i++) {
      const cols = lines[i].split(",");
      if (cols.length < 3) continue;

      const subject = (cols[0] || "").trim();
      const unitName = (cols[1] || "").trim();
      const requiredSessions = (cols[2] || "").trim();
      const deadline = (cols[3] || "").trim();

      if (!subject || !unitName) continue;

      result.push({
        subject,
        unitName,
        requiredSessions: Number(requiredSessions) || 0,
        deadline: deadline || null,
      });
    }

    return result;
  };

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const text = await file.text();
    const rows = parseCsv(text);
    if (rows.length && onImported) {
      onImported(rows);
    }
    e.target.value = "";
  };

  return (
    <div className="mb-4">
      <p className="text-sm text-gray-600 mb-1">
        CSVから追加（科目,単元名,必要コマ数,期限）
      </p>
      <input type="file" accept=".csv,text/csv" onChange={handleFile} />
    </div>
  );
};

export default CurriculumCsvUpload;
